"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torri-in-sabina": {
    "b08730ba": [{
      "hkey": "b131e515",
      "slug": "torri-in-sabina",
      "name": "Torri in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-in-vescovio": [{
      "hkey": "b131e515",
      "slug": "torri-in-sabina",
      "name": "Torri in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;